"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ArticleListingDefaultProps = exports.ArticleListing = void 0;
var _articleListing = _interopRequireDefault(require("./components/article-listing"));
exports.ArticleListing = _articleListing["default"];
var _articleListing2 = _interopRequireDefault(require("./components/article-listing.props/article-listing.defaultProps"));
exports.ArticleListingDefaultProps = _articleListing2["default"];